import React from 'react';
import * as R from 'ramda';
import { Labeled, TextField } from 'react-admin';
import { Box } from '@material-ui/core';
import { DateField } from 'resources/common';

const FIXED_VALUES = new Set(['Never', 'Unknown']);

/**
 * Renders publication.last_published from the backend. No business-state logic.
 */
const CourseLastPublishedField = ({ record, source }) => {
  const lastPublished = R.path([source, 'publication', 'last_published'], record);
  if (!lastPublished || !lastPublished.render) {
    return null;
  }

  const { label, value } = lastPublished;
  const isFixed = FIXED_VALUES.has(value);
  const showTime = label === 'Last published';

  return (
    <Box>
      <Labeled label={label || 'Last published'}>
        {isFixed || !value ? (
          <TextField
            source={`${source}.publication.last_published.value`}
            record={record}
          />
        ) : (
          <DateField
            source={`${source}.publication.last_published.value`}
            record={record}
            showTime={showTime}
          />
        )}
      </Labeled>
    </Box>
  );
};

export default CourseLastPublishedField;
